/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 17:03:32
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-11 14:46:48
 * @FilePath: /chaoyongtuan/src/api/contentLibray.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 内容库

// 本地素材
export const materialLibraryList = params => {
	return request({
		url: '/micro-cyt/material-library/page',
		data: params,
		method: AjaxMethod.post,
	});
};

// 获取素材资源
export const getMaterialSource = (params) => {
    return request({
		url: '/micro-cyt/material-library/get-material-source',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
}

// 获取素材配置
export const getMaterialConfig = (params) => {
	return request({
		url: '/micro-cyt/material-library/get-material-config',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
}

// 批量下载
export const batchDownload = (params) => {
    return request({
		url: '/micro-cyt/material-library/batch-download',
		data: params,
		method: AjaxMethod.post,
	});
}

// 素材批量打标
export const batchTagging = (params) => {
	return request({
		url: '/micro-cyt/material-library/batch-tagging',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	}); 
}

// 检验存储空间
export const checkStorageSpace = (params) => {
    return request({
		url: '/micro-cyt/material-library/check-size',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
}

// 更新素材备注
export const updateMaterialRemark = (params) => {
	return request({
		url: '/micro-cyt/material-library/update-material-remark',
		data: params,
		method: AjaxMethod.post,
	});
}

// 更新素材标题
export const updateMaterialTitle = (params) => {
    return request({
		url: '/micro-cyt/material-library/update-material-title',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
}

// 保存素材配置
export const saveMaterialConfig = (params) => {
    return request({
		url: '/micro-cyt/material-library/save-material-config',
		data: params,
		method: AjaxMethod.post,
	});
}

// 批量保存素材
export const batchSaveMaterial = (params) => {
    return request({
		url: '/micro-cyt/material-library/batch-save',
		data: params,
		method: AjaxMethod.post,
	});
}

// 批量删除素材
export const batchDeleteMaterial = (params) => {
	return request({
		url: '/micro-cyt/material-library/batch-del',
		data: params,
		method: AjaxMethod.post,
	});
}
